module.exports = __webpack_public_path__ + "media/application/images/company/founders-bw/Gordon-Stove-630db79b95a828870a24ac54b70cda39.jpg";